var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomNavigationAction = void 0;
var BottomNavigationAction_1 = __importDefault(require("./BottomNavigationAction"));
exports.BottomNavigationAction = BottomNavigationAction_1.default;
exports.default = BottomNavigationAction_1.default;
//# sourceMappingURL=index.js.map